var link_viewer_default = {
  "fontElementMap": "mhHCb",
  "link": "Hfcbn",
  "linkInEditor": "_8bLtG",
  "linkInViewer": "HWatM",
  "toolbarUrlContainer": "_7fu8L",
  "toolbarUrl": "IEKwI",
  "toolbarUrlAnchor": "-xbqU"
};
export {
  link_viewer_default as default
};
//# sourceMappingURL=link-viewer-scss.js.map
